<div class="card bg-white relative border-none">
  <div class="card-header p-3 sm:p-5">
    <div class="flex items-center justify-between">
      <p class="flex mb-0 pb-0 text-primaryDark text-lg sm:text-xl font-bold">
        <span i18n>Prijava v CarPeak</span>
      </p>
      <button (click)="close()"
              class="btn border-transparent shadow-none text-gray hover:text-grayDark fadeInFadeOut">
        <i class="fas fa-times text-lg"></i>
      </button>
    </div>
  </div>

  <div class="card-content pt-0">
    <div *ngIf="isLoading" class="flex justify-center items-center py-12">
      <i class="fas fa-spinner fa-spin text-3xl text-primary"></i>
    </div>

    <div *ngIf="errorMessage && !isLoading" class="text-center py-8">
      <ng-container *ngIf="errorReason === 'account_setup_incomplete'; else genericError">
        <div class="flex justify-center mb-4">
          <i class="fas fa-exclamation-triangle text-3xl text-yellow"></i>
        </div>
        <p class="text-grayDark mb-4">{{ errorMessage }}</p>
        <p *ngIf="requiredActions.length" class="text-xs text-gray mb-4" i18n>
          Zahtevani koraki: {{ requiredActions.join(', ') }}
        </p>
        <button class="btn btn-primary" (click)="close()" i18n>V redu</button>
      </ng-container>

      <ng-template #genericError>
        <p class="text-red mb-4">{{ errorMessage }}</p>
        <button class="btn btn-primary" (click)="loadQrToken()" i18n>Poskusi znova</button>
      </ng-template>
    </div>

    <ng-container *ngIf="!isLoading && !errorMessage && qrData">
      <p class="text-sm text-grayDark mb-4" i18n>
        Skenirajte QR kodo z aplikacijo <strong>CarPeak</strong> za hitro prijavo.
      </p>

      <div class="flex justify-center mb-4">
        <qrcode
          [qrdata]="qrData"
          [width]="400"
          [errorCorrectionLevel]="'M'"
          [margin]="2">
        </qrcode>
      </div>
    </ng-container>
  </div>
</div>
